<template>
    <v-tabs v-bind="$attrs">
        <template v-for="{ text, value, to } in items">
            <v-tab :key="value" v-bind="{ value, to }" exact>{{ text }}</v-tab>
        </template>
        <v-spacer />
        <v-divider vertical />
        <prompt-list-groups-form :value="setting" @input="init">
            <template #activator="{ attrs, on }">
                <v-btn text fab tile width="48" height="48" v-bind="attrs" v-on="on">
                    <v-icon dense>mdi-cog</v-icon>
                </v-btn>
            </template>
        </prompt-list-groups-form>
    </v-tabs>
</template>

<script>
import { mapActions, mapState } from "vuex";

import PromptListGroupsForm from "./groups/prompt-list-groups-form.vue";

export default {
    components: {
        PromptListGroupsForm,
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        ...mapState("common/setting", {
            setting: (state) => state.data,
            chatPromptGroups: (state) => state.data?.chatPromptGroups || [],
        }),
        items() {
            return [{ text: "전체", value: null }, ...(this.chatPromptGroups || [])].map((item) => {
                const to = {
                    path: "/console/chat/prompts",
                    query: { group: item.value },
                };
                if (!item.value) delete to.query.group;
                return { ...item, to };
            });
        },
    },
    methods: {
        ...mapActions("common/setting", ["getData"]),

        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                await this.getData({ isConsole: true });
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style></style>
